import { useEffect } from 'react'
import { BRAND_TAGLINE } from '../constants/brand.js'

/** Homepage / share-preview title — full locked tagline (no HealBerry — prefix). */
const DEFAULT_TITLE = BRAND_TAGLINE
const DEFAULT_DESCRIPTION = BRAND_TAGLINE

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setMetaDescription(content) {
  setMeta('name', 'description', content)
}

function setOgTitle(content) {
  setMeta('property', 'og:title', content)
}

/**
 * Sets document.title, meta description, and og:title for the current route.
 * Restores site defaults on unmount.
 */
export function usePageMeta(title, description) {
  useEffect(() => {
    const next_title = title || DEFAULT_TITLE
    const prevTitle = document.title
    const prevDesc =
      document.querySelector('meta[name="description"]')?.getAttribute('content') ||
      DEFAULT_DESCRIPTION
    const prevOg =
      document.querySelector('meta[property="og:title"]')?.getAttribute('content') ||
      DEFAULT_TITLE

    document.title = next_title
    setOgTitle(next_title)
    if (description) setMetaDescription(description)

    return () => {
      document.title = prevTitle || DEFAULT_TITLE
      setOgTitle(prevOg || DEFAULT_TITLE)
      setMetaDescription(prevDesc || DEFAULT_DESCRIPTION)
    }
  }, [title, description])
}
